<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">系统设置</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>海报设置</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      <create-list @refresh="refreshList"/>
      <poster-list @refresh="refreshList"></poster-list>
    </el-card>
  </div>
</template>

<script>
import './store';
import { mapActions } from 'vuex';
import PosterList from './components/list';
import CreateList from './components/create';

export default {
  name: 'poster',
  data() {
    return {
      posterType: 1,
      pager: {
        page: 1,
        size: 10
      }
    };
  },
  components: {
    PosterList,
    CreateList
  },
  methods: {
    ...mapActions('poster', ['list']),
    refreshList() {
      this.list({ posterType: this.posterType, ...this.pager });
    }
  },
  mounted() {
    this.list({ posterType: this.posterType, ...this.pager });
  }
};
</script>

<style lang="less" scoped></style>
